

























import {Component, Prop, Mixins, Watch} from 'vue-property-decorator'
import Translation from '@/mixins/Translation'
import DaumPostcode from '@/components/DaumPostcode.vue'
import BttPopup from '@/components/popup/btt/BttPopup.vue'
import FooterButton from '@/components/popup/btt/FooterButton.vue'
import {Input} from 'element-ui'

@Component({
  components: {BttPopup, DaumPostcode, [Input.name]: Input, FooterButton},
})
export default class SearchAddressPopup extends Mixins(Translation) {
  @Prop({default: null, type: Boolean}) value: boolean
  @Prop({default: 'terms', type: String}) translation: string

  open: boolean = false
  daumPostCodeVisible: boolean = false

  address: string = ''
  detailAddress: string = ''

  @Watch('value')
  __value(value) {
    this.open = value
    this.daumPostCodeVisible = value
    this.address = ''
    this.detailAddress = ''
  }

  onClose() {
    this.$emit('input', false)
  }

  onHandlePopup(value) {
    this.$emit('input', value)
  }

  onSelectAddress({userSelectValue = ''}) {
    this.address = userSelectValue
  }

  onClickConfirm() {
    const result = [this.address, this.detailAddress].filter((v) => v).join(' ')
    this.$emit('select-address', result)
    this.onClose()
  }
}
